import { alpha, styled } from '@mui/material';
import Box from '@mui/material/Box';

import { Text } from '@knowz/knowz-ui';

export const StyledGradientCard = styled(Box)(({ theme }) => ({
  background: theme.palette.createBrandGradients.primary(
    theme.palette.mode === 'dark'
      ? {
          alpha1: alpha(theme.palette.common.black, 0.1),
          alpha2: alpha(theme.palette.common.black, 0.6),
        }
      : {
          alpha1: alpha(theme.palette.common.white, 0.1),
          alpha2: alpha(theme.palette.common.white, 0.8),
        },
  ),
  padding: theme.spacing(4),
  borderRadius: theme.shape.borderRadius * 3,
}));

export const StyledText = styled(Text)(({ theme }) => ({
  marginBlockEnd: theme.spacing(3),
}));
